module.exports = __webpack_public_path__ + "assets/pdf/BN05-en-heatwave-cities.a3b4bee7.pdf";